import styled, { css } from 'styled-components';

import { colors } from '../../styles/tokens';

export type PillButtonVariant = 'solid' | 'ghost' | 'highlight';
export type PillButtonSize = 'md' | 'lg';

interface StyledPillButtonProps {
  variant: PillButtonVariant;
  size: PillButtonSize;
  fullWidth?: boolean;
}

const variantStyles = {
  solid: css`
    background: ${colors.primary};
    border: 1px solid ${colors.primary};
    color: ${colors.onPrimary};

    &:hover {
      background: ${colors.primaryHover};
      border-color: ${colors.primaryHover};
    }
  `,
  ghost: css`
    background: transparent;
    border: 1px solid ${colors.border};
    color: ${colors.textPrimary};

    &:hover {
      border-color: ${colors.primary};
      color: ${colors.primary};
    }
  `,
  highlight: css`
    background: transparent;
    border: 1px solid ${colors.borderAccent};
    color: ${colors.textPrimary};

    &:hover {
      border-color: ${colors.primary};
      color: ${colors.primary};
    }
  `,
};

const sizeStyles = {
  md: css`
    padding: 11px 20px;
    font-size: 14px;
  `,
  lg: css`
    padding: 18px 30px;
    font-size: 16px;
  `,
};

export const StyledPillButton = styled.a<StyledPillButtonProps>`
  display: ${props => (props.fullWidth ? 'flex' : 'inline-flex')};
  align-items: center;
  justify-content: center;
  gap: 8px;

  border-radius: 999px;
  font-weight: 800;
  letter-spacing: -0.01em;
  text-align: center;
  cursor: pointer;
  transition: background-color 0.2s, border-color 0.2s, color 0.2s;

  ${props => variantStyles[props.variant]}
  ${props => sizeStyles[props.size]}
`;
